import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ResourceService } from '@teem/generic/resource.service';
import { client as ClientApi } from '@teem/constants/api';
import { Client, ClientSerializer } from '@teem/models/client';
import { objectToFormData } from '@teem/helpers/functions';

@Injectable({
  providedIn: 'root'
})
export class ClientService extends ResourceService<Client> {

  constructor(protected httpClient: HttpClient) {
    super(
      httpClient,
      ClientApi.endPoint,
      new ClientSerializer()
    )
  }

  public list(): Observable<Client[]> {
    return this.httpClient.get(`${ClientApi.list}`, this.httpOptions)
      .pipe(map((r: any) => this.convertData(r)));
  }

  public updateName(id: string, params: any) {
    return this.httpClient.patch(`${ClientApi.updateName(id)}`, params, this.httpOptions)
  }

  public invoices(id: string, queryOptions?: any) {
    return this.httpClient.get(`${ClientApi.projects(id)}${queryOptions ? ('?' + this.toQueryString(queryOptions)) : ""}`, this.httpOptions);
  }

  public importFile(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      // fd.append('_method', 'put');
      return this.httpClient.post(`${ClientApi.importFile}`, fd)
    } else {
      return this.httpClient.put(`${ClientApi.importFile}`, params)
    }
  }
}
